import { useCreate } from '@refinedev/core';
import { DocumentVersion } from './useDocumentVersions';

type CreateDocumentVersionPayload = {
  markdownContent: string;
  markdownContentWithMarkers?: string;
};

export function useCreateDocumentVersion(documentId?: string) {
  const { mutateAsync, error, isLoading, reset } = useCreate<DocumentVersion>();

  const createDocumentVersion = async (values: CreateDocumentVersionPayload) => {
    if (!documentId) throw new Error('documentId is required');
    return mutateAsync({
      resource: `documents/${documentId}/versions`,
      values,
    });
  };

  return {
    createDocumentVersion,
    error,
    isLoading,
    reset,
  };
}
